import { EventItem } from '../../../domain/EventItem'
import { calcDays, HistoryCriteria } from '../../../domain/history/HistoryCriteria'
import { ApplicationState } from '../../ApplicationState'
import { getEventState } from '../V2State'
import { eventKey } from './common'

export interface EventState {
    byKey: { [key: string]: EventItem[] }
    loaded: boolean
}

export const getEvents = (state: ApplicationState, day: string, environment: string, service: string): EventItem[] =>
    getEventState(state).byKey[eventKey(environment, service, day)] || []

export const getEventsForHistory = (state: ApplicationState, criteria: HistoryCriteria): EventItem[] => {
    const { environment, service, date, granularity } = criteria

    return calcDays(date, granularity).reduce(
        (all: EventItem[], day: string): EventItem[] => [...getEvents(state, day, environment, service), ...all],
        [],
    )
}
